import { zIndex } from "@nova/constants"
import * as Icons from "@nova/component-icons"
import { useAppSelector } from "integrations/redux/hooks"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectLocationOverrideProjectId } from "features/overview/slice"
import { UpdateLocationHeader } from "./UpdateLocationHeader"
import { LocationOverrideCrosshair } from "./LocationOverrideCrosshair"
import { useProjectLayerGeometry } from "./useProjectLayerGeometry"

export const UpdateLocationModeOverlay = () => {
    const projectId = useAppSelector(selectLocationOverrideProjectId)
    const orgId = useAppSelector(selectActiveWorkspaceId())
    const { loading } = useProjectLayerGeometry({ orgId, projectId, enabled: !!projectId })

    return (
        <div
            className="absolute inset-0 pointer-events-none"
            style={{ zIndex: zIndex.InspectorPanel + 1 }}
        >
            <div className="absolute top-0 inset-x-0">
                <UpdateLocationHeader />
            </div>
            <LocationOverrideCrosshair />
            {loading && (
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[72px] pointer-events-none">
                    <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-black-800 backdrop-blur-sm whitespace-nowrap">
                        <Icons.SmallIcon Icon={Icons.Information} className="text-gray-100" />
                        <small className="text-white">Loading your {"project's"} layers.</small>
                    </div>
                </div>
            )}
        </div>
    )
}
